import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const MailIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2zm0 4v10h16V8l-8 5-8-5zm0-2 8 5 8-5H4z" />
    </SvgIcon>
  );
};

export default MailIcon;
